import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MLButton from '../../../../components/MLButton';
import MLIcon from '../../../../components/MLIcon';
import ManualAssignments from '../../../modals/ManualAssignments/ManualAssignments';
import { addManualAssignment } from '../../../../actions/analyticsEvents';

import s from './ManualAssignmentsMenu.module.css';

const ManualAssignmentsMenu = ({
  dispatch,
  sendEvent,
  courseId,
  isDisabled,
  disableEnforceFocus,
}) => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  const onClickButton = () => {
    setShowCreateModal(true);
    dispatch(sendEvent(addManualAssignment(courseId)));
  };

  return (
    <div>
      {showCreateModal && (
        <ManualAssignments
          showModal={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          disableEnforceFocus={disableEnforceFocus}
        />
      )}
      <MLButton
        btnType="secondary"
        onClick={onClickButton}
        testId="add-manual-assignment"
        disabled={isDisabled}
      >
        <MLIcon
          type="plus"
          className={classnames(s.headerBtnIcon, {
            [s.headerBtnIconDisabled]: isDisabled,
          })}
        />
        <span>Add a Non-Achieve Assignment</span>
      </MLButton>
    </div>
  );
};

ManualAssignmentsMenu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sendEvent: PropTypes.func.isRequired,
  courseId: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  disableEnforceFocus: PropTypes.bool,
};

export default ManualAssignmentsMenu;
